<template>
  <el-dropdown class="my_select" trigger="click" size="small" @command="handleCommand" @visible-change="visibleChange">
    <div class="show_box">
      <p :class="placeholder">{{title}}</p>
      <p class="select_text">{{showText}}</p>
      <i @click.stop="clearSelect" class="el-icon-error clear" v-show="this.showText.length!==0"></i>
      <i class="el-icon-arrow-down icon" :class="visible?'rotate':''"></i>
    </div>
    <el-dropdown-menu slot="dropdown" :class="isDropArea?'dropArea':'dropNormal'">
      <el-dropdown-item
        v-for="(item,index) in data"
        :key="index"
        :command="item"
      >
        {{item.label}}
      </el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>

export default {
  name: 'MySelect',
  props: {
    value: {
      type: [String, Number],
      default () {
        return ''
      }
    },
    data: {
      type: Array,
      default () {
        return []
      }
    },
    title: {
      type: [String],
      default () {
        return ''
      }
    },
    isDropArea: {
      type: Boolean,
      default () {
        return false
      }
    }
  },
  data () {
    return {
      showText: '',
      visible: false,
      onFocus: false
    }
  },
  computed: {
    placeholder () {
      if (this.showText || this.onFocus) {
        return 'placeholder top'
      } else {
        return 'placeholder'
      }
    }
  },
  watch: {
    value (now, before) {
      if (now === before) return
      this.checkSelect()
    },
    data (now, before) {
      if (now === before) return
      this.checkSelect()
    }
  },
  mounted () {
    this.checkSelect()
  },
  methods: {
    // handleFocus (event) {
    //   this.onFocus = true
    // },
    handleBlur (event) {
      this.onFocus = false
      this.$emit('on-blur', event)
    },
    handleCommand (data) {
      this.showText = data.label
      this.$emit('input', data.value)
    },
    visibleChange (value) {
      this.onFocus = value
      if (!this.data.length && value) this.$emit('get-data')
      this.visible = value
    },
    clearSelect () {
      this.onFocus = false
      this.$emit('input', '')
    },
    checkSelect () {
      let selectData = this.data.find(item => {
        if (item.value === this.value) return true
      })
      if (selectData) {
        this.showText = selectData.label
      } else {
        this.showText = ''
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.my_select {
  float: left;
  width: 180px;
  height: 50px;
  vertical-align: top;
  cursor: pointer;
}
.dropNormal {
  width: 180px;
  max-height: 200px;
  overflow: auto
}
.dropArea {
  width: 555px;
  max-height: 200px;
  overflow: auto;
  li {
    float: left;
    width: 135px;
    cursor: pointer;
  }
}
.show_box {
  position: relative;
  width: 180px;
  height: 50px;
  border-bottom: 1px solid #282729;
  .placeholder {
    position: relative;
    top: 24px;
    color: #282729;
    font-size: 16px;
    line-height: 14px;
    -webkit-transition: all 0.1s;
    transition: all 0.1s;
  }
  .top {
    top: 0;
    font-size: 12px;
    color: #999999;
  }
  .select_text {
    font-size: 16px;
    position: relative;
    top: 8px;
    color: #4B4F58;
  }
  .clear {
    display: none;
    position: absolute;
    top: 28px;
    right: 28px;
    color: #282729;
  }
  &:hover {
    .clear {
      display: block;
    }
  }
  .icon {
    position: absolute;
    top: 28px;
    right: 8px;
    font-size: 14px;
    color: #282729;
    font-weight: 600;
    -webkit-transition: all .3s;
    transition: all .3s;
  }
  .rotate {
    transform: rotate(180deg)
  }
}
</style>
